module.exports = __WEBPACK_EXTERNAL_MODULE_67__;


/*****************
 ** WEBPACK FOOTER
 ** external "moment"
 ** module id = 67
 ** module chunks = 0
 **/